import React from 'react';

export const LikeSVG = props => {
	const { id } = props;

	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='64' height='64'
viewBox='0 0 64 64'
		>
			<defs>
				<linearGradient
					id='swipe-gradient-like'
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#b5d334'>
						<animate
							id={`trans4-${id}`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#7b868c'>
						<animate
							id={`trans4-${id}`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id='lpfon493yb'
					x1='.875'
					x2='.004'
					y1='.788'
					y2='.107'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#c1c5c8' />
					<stop offset='1' />
				</linearGradient>
				<linearGradient
					id='lgyziqlmvc'
					x1='.793'
					x2='-.166'
					y1='.783'
					y2='-.283'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#fff' />
					<stop offset='1' stop-color='#a2a9ad' />
				</linearGradient>
				<linearGradient
					id='n8s0o91nhd'
					x1='1'
					x2='1'
					y1='1.21'
					y2='.614'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#dfe1e1' />
					<stop offset='1' stop-color='#fff' />
				</linearGradient>
				<linearGradient
					id='phcntqf5be'
					x1='.634'
					x2='-.924'
					y1='.757'
					y2='-.211'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#cfd2d3' />
					<stop offset='1' stop-color='#7b868c' />
				</linearGradient>
				<clipPath id='7yczeou21a'>
					<circle cx='32' cy='32' r='32'
fill='#f23722' transform='translate(0 .476)'
					/>
				</clipPath>
			</defs>
			<g clip-path='url(#7yczeou21a)' transform='translate(0 -.476)'>
				<circle
					cx='32'
					cy='32'
					r='32'
					fill='url(#swipe-gradient-like)'
					transform='translate(0 .476)'
				/>
				<path
					fill='url(#lpfon493yb)'
					d='M37.472 68.38l23.747 18.6 19.617-12.408 8.108-18.451-13.53-10.483-4.052-1.956-10.144-8.973-13 17.431z'
					opacity='0.25'
					transform='translate(-22.6 -22.022)'
				/>
				<g>
					<path
						fill='#fff'
						d='M26.437 15.653v-7.8A5.851 5.851 0 0 0 20.586 2l-7.8 17.554V41.01h22a3.9 3.9 0 0 0 3.9-3.316l2.692-17.554a3.9 3.9 0 0 0-3.271-4.44 3.789 3.789 0 0 0-.63-.045zM12.784 41.01H4.9a3.9 3.9 0 0 1-3.9-3.9V23.455a3.9 3.9 0 0 1 3.9-3.9h7.883'
						transform='translate(11.8 7.396) translate(-1 -2)'
					/>
					<path
						fill='url(#lgyziqlmvc)'
						d='M25.406 15.653v-7.8A5.851 5.851 0 0 0 19.554 2l-7.8 17.554V41.01h22a3.9 3.9 0 0 0 3.9-3.316l2.692-17.554a3.9 3.9 0 0 0-3.271-4.44 3.789 3.789 0 0 0-.63-.045zM11.752 41.01H5.9a3.9 3.9 0 0 1-3.9-3.9V23.455a3.9 3.9 0 0 1 3.9-3.9h5.851'
						transform='translate(11.8 7.396) translate(1.438 -.793)'
					/>
					<path
						fill='url(#n8s0o91nhd)'
						d='M11.752 37.855H5.9a3.9 3.9 0 0 1-3.9-3.9V20.3a3.9 3.9 0 0 1 3.9-3.9h5.851'
						transform='translate(11.8 7.396) translate(1.438 2.362)'
					/>
					<path
						fill='url(#phcntqf5be)'
						d='M9.924 37.855H5.9a3.9 3.9 0 0 1-3.9-3.9V20.3a3.9 3.9 0 0 1 3.9-3.9h4.024'
						transform='translate(11.8 7.396) translate(-.4 2.362)'
					/>
				</g>
			</g>
		</svg>
	);
};
